import { AdminRouter } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

AdminRouter.addRoute({
  path: '/',
  name: 'dashboard',
  component: () => import('./Dashboard.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  path: '/charts/earning',
  component: () => import('./Earning.vue'),
  meta: {
    auth: true,
  },
})

messageGroups.push('graphs')
